// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auth Container */
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: var(--space-xl) 0;
}

.auth-card {
  max-width: 450px;
  width: 100%;
  box-shadow: var(--shadow-xl);
}

/* Auth Header */
.auth-header {
  text-align: center;
  margin-bottom: var(--space-xl);
}

.auth-icon {
  font-size: 4rem;
  margin-bottom: var(--space-md);
  animation: float 3s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.auth-header h2 {
  font-size: var(--font-size-3xl);
  margin-bottom: var(--space-sm);
  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.auth-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: var(--font-size-base);
  margin: 0;
}

/* Auth Form */
.auth-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

.auth-submit-btn {
  margin-top: var(--space-md);
}

/* Auth Footer */
.auth-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
  font-size: var(--font-size-sm);
}

/* Alert Component */
.alert {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  padding: var(--space-md);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.alert-error {
  background: rgba(239, 68, 68, 0.15);
  border: 2px solid var(--color-error);
  color: var(--color-error-light);
}

.alert-success {
  background: rgba(76, 175, 80, 0.15);
  border: 2px solid var(--color-success);
  color: var(--color-success-light);
}

.alert-warning {
  background: rgba(255, 152, 0, 0.15);
  border: 2px solid var(--color-warning);
  color: var(--color-warning-light);
}

.alert-info {
  background: rgba(33, 150, 243, 0.15);
  border: 2px solid var(--color-info);
  color: var(--color-info-light);
}

.alert-icon {
  font-size: var(--font-size-lg);
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Auth.css"],"names":[],"mappings":"AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB","sourcesContent":["@import '../styles/variables.css';\n\n/* Auth Container */\n.auth-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n  padding: var(--space-xl) 0;\n}\n\n.auth-card {\n  max-width: 450px;\n  width: 100%;\n  box-shadow: var(--shadow-xl);\n}\n\n/* Auth Header */\n.auth-header {\n  text-align: center;\n  margin-bottom: var(--space-xl);\n}\n\n.auth-icon {\n  font-size: 4rem;\n  margin-bottom: var(--space-md);\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.auth-header h2 {\n  font-size: var(--font-size-3xl);\n  margin-bottom: var(--space-sm);\n  background: linear-gradient(135deg, #ffffff 0%, #e0e7ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.auth-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: var(--font-size-base);\n  margin: 0;\n}\n\n/* Auth Form */\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n}\n\n.auth-submit-btn {\n  margin-top: var(--space-md);\n}\n\n/* Auth Footer */\n.auth-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  width: 100%;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: var(--font-size-sm);\n}\n\n/* Alert Component */\n.alert {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  padding: var(--space-md);\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.alert-error {\n  background: rgba(239, 68, 68, 0.15);\n  border: 2px solid var(--color-error);\n  color: var(--color-error-light);\n}\n\n.alert-success {\n  background: rgba(76, 175, 80, 0.15);\n  border: 2px solid var(--color-success);\n  color: var(--color-success-light);\n}\n\n.alert-warning {\n  background: rgba(255, 152, 0, 0.15);\n  border: 2px solid var(--color-warning);\n  color: var(--color-warning-light);\n}\n\n.alert-info {\n  background: rgba(33, 150, 243, 0.15);\n  border: 2px solid var(--color-info);\n  color: var(--color-info-light);\n}\n\n.alert-icon {\n  font-size: var(--font-size-lg);\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
